import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Start each newly opened screen at the top. Without it, opening a course,
 * game or task from a card far down a long phone list landed partway down
 * the new screen. Back/forward (POP) is left to the browser's own scroll
 * restoration, so returning to a list keeps your place.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    // 'instant' so the global `scroll-behavior: smooth` doesn't animate a
    // whole page's worth of scrolling on every navigation.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname, navigationType]);

  return null;
}
